<template>
  <section class="pop-room contact-pop">
    <a href="javascript:;" @click="setContactHide()" class="iconfont icon-close"></a>
    <div class="select-result">

    </div>
    <div class="pop-cont">
      <div class="contacts-tree" v-if="showTree">
        <!-- 通讯录树形结构 -->
        <el-tree ref="tree" :data="contactData" :props="defaultProps" node-key="depId" @node-click="handleNodeClick"
          :expand-on-click-node="false" :highlight-current="true" :default-expanded-keys="defaultExpandedKey"></el-tree>
      </div>
      <div class="component-content">
        <el-button v-if="isMobile" @click="showTree=!showTree" size="mini" type="primary">切换公司</el-button>
        <div class="title">
          <el-input class="search-input" v-model="searchKey" size="mini" placeholder="请输入同事姓名模糊搜索"></el-input>
        </div>
        <el-table ref="contactsTable" :key="tableKey" :data="filterData" style="width: 100%" v-loading="loading">
          <el-table-column label="" width="40">
            <template slot-scope="scope">
              <input type="checkbox" v-model="checkboxArr[scope.row.id]" @change="selectedChange(scope.row)">
            </template>
          </el-table-column>
          <el-table-column prop="name" label="姓名">
          </el-table-column>
          <el-table-column prop="position" label="职务">
          </el-table-column>
          <el-table-column prop="department" label="部门">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="btn-room">
      <el-button @click="successSelect()" type="primary">确认选择</el-button>
    </div>
  </section>
</template>
<script>
  import {
    mapState
  } from "vuex";
  export default {
    computed: {
      ...mapState({
        contactCurNode: state => state.main.contactCurNode,
        contactSelectArr: state => state.main.contactSelectArr,
        contactApprovalDep: state => state.main.contactApprovalDep,
        contactSingleSelect: state => state.main.contactSingleSelect,

        isMobile: state => state.main.isMobile,
        organization: state => state.main.organization,
        employeeList: state => state.main.employeeList,
      })
    },
    data() {
      return {
        defaultExpandedKey: [42],
        searchKey: "",
        nowContactApprovalDep: '',

        // 导航
        contactData: [],
        defaultProps: {
          children: 'childDepts',
          label: 'name'
        },

        showTree: true,

        // 列表
        loading: true,
        listData: [],
        filterData: [],
        // 已选择的人员数组
        selectArr: [],
        checkboxArr: [],

        tableKey: new Date().getTime(),
      }
    },
    created() {
      if (this.isMobile) {
        this.showTree = false
      }
    },
    mounted() {
      this.selectArr = this.contactSelectArr
      this.getContactsList()
      // 选上默认的项目
      for (var i = 0; i < this.selectArr.length; i++) {
        this.$set(this.checkboxArr, this.selectArr[i].id, true)
      }

      this.defaultExpandedKey = [1]
      this.nowContactApprovalDep = this.contactApprovalDep / 1
      if (!this.nowContactApprovalDep && this.selectArr.length > 0) {
        console.log(this.selectArr)
        this.nowContactApprovalDep = this.selectArr[0].childDepId / 1
      }

      this.defaultExpandedKey.push(this.nowContactApprovalDep)
      // console.log(this.defaultExpandedKey)

      if (this.nowContactApprovalDep) {
        this.getLists(this.nowContactApprovalDep)
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.nowContactApprovalDep)
        })
      } else {
        this.getLists(1)
      }
    },
    components: {},
    methods: {
      successSelect() {
        console.log('pop',this.selectArr)

        this.$store.commit('set_contactSelectArr', this.selectArr)
        this.setContactHide()
      },
      // 选中checkbox事件
      selectedChange(row) {
        let _has = false
        let _index
        for (var i = 0; i < this.selectArr.length; i++) {
          var _item = this.selectArr[i]
          if (row.id == _item.id) {
            _index = i
            _has = true
          }
        }
        if (_has) {
          this.selectArr.splice(_index, 1);

          this.$set(this.checkboxArr, row.id, false)
        } else {
          if (this.contactSingleSelect) {
            this.selectArr = []
          }
          this.selectArr.push(row)
          this.$set(this.checkboxArr, row.id, true)
          if (this.contactSingleSelect) {
            this.$store.commit('set_contactSelectArr', this.selectArr)
            this.setContactHide()
          }
        }
      },
      // 是否选中
      isSelected(row) {
        console.log(this.selectArr.indexOf(row))
        return this.selectArr.indexOf(row) == -1 ? false : true
      },
      // 隐藏人物选择弹窗
      setContactHide() {
        this.$store.commit('set_contactShow', false)
        this.$store.commit("set_contactCurNode", {})
      },
      // 获取组织架构列表
      getContactsList() {
        if (this.organization.length > 0) {
          this.contactData = this.organization
        } else {
          ajax.get('/dept/list', '', (res) => {
            this.contactData = res.vo.array
            this.$store.commit('set_organization', res.vo.array)
          })
        }
      },
      // 点击目录
      handleNodeClick(data) {
        if (this.isMobile) {
          this.showTree = false
        }
        this.$store.commit("set_contactCurNode", data)
      },
      // 搜索筛选新闻数据
      getFilterData() {
        if (this.searchKey) {
          // 筛选出所有符合的数据
          this.filterData = []
          for (let i = 0; i < this.listData.length; i++) {
            let _new = this.listData[i]
            if (_new.name.indexOf(this.searchKey) != -1) {
              this.filterData.push(_new)
            }
          }
        } else {
          this.filterData = this.listData
        }
      },
      // 获取列表
      getLists(_depId) {
        if ((_depId == "" || _depId == 1) && this.employeeList.length > 0) {
          this.$nextTick(() => {
            this.loading = false
            this.filterData = this.listData = this.employeeList
          })
        } else {
          ajax.get('/dept/users', {
            'deptId': _depId
          }, (res) => {
            this.loading = false
            this.filterData = this.listData = res.vo.array
            if ((_depId == "" || _depId == 1)) {
              this.$store.commit('set_employeeList', res.vo.array)
            }
          })
        }
      },
    },
    watch: {
      contactCurNode() {
        this.loading = true
        this.getLists(this.contactCurNode.depId)
        this.tableKey = new Date().getTime()
      },
      searchKey() {
        if (this.searchKey) {
          this.getFilterData()
        } else {
          this.filterData = this.listData
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/ContactsPop.vue